<template>
  <div
    id="__kk_slide_unlock"
    v-if="isShow"
    @click.self="control(false)"
  >
    <div class="__kk_slide_unlock_inner">
      <div class="__kk_slide_unlock_pic_box">
        <div
          class="__kk_slide_unlock_pic"
          :style="{'background-image':`url('${basePic}')`}"
        >
          <div
            class="__kk_slide_unlock_pic_part"
            :style="{'top':picPartPositionY,'left':positionLeft,'background-image':`url('${sliderPic}')`}"
          ></div>
        </div>
      </div>
      <div class="__kk_slide_unlock_drag">
        <div
          class="__kk_slide_unlock_drag_bar"
          :style="{'width':positionLeft}"
        ></div>
        <div
          class="__kk_slide_unlock_drag_tag"
          :style="{'left':positionLeft}"
          @mousedown="mouseDownEvent"
          @touchstart="mouseDownEvent"
        ></div>
        <span class="__kk_slide_unlock_drag_tip">鼠标拖动滑块完成拼图</span>
      </div>
      <div class="__kk_slide_unlock_operate">
        <div></div>
        <div>
          <div
            class="__kk_slide_unlock_operate_refresh"
            @click="reset"
          >
            <i class="iconfont icon-refresh"></i>
          </div>
          <div
            class="__kk_slide_unlock_operate_close"
            @click="control(false)"
          >
            <i class="iconfont icon-close"></i>
          </div>
        </div>
      </div>
      <div
        class="__kk_slide_unlock_loading"
        v-show="loading"
      >
        <div class="__kk_slide_unlock_loading_tag">
          <i class="iconfont icon-refresh"></i>
        </div>
        <span style="padding-left:10px;">加载中 ...</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    validate: Function,
    getData: Function
  },
  data() {
    return {
      loading: false,
      dratStart: false,//拖动开始
      basePic: '',//背景图
      sliderPic: '',//滑动块图片
      picPartPositionY: '0px',//图片补缺部分Y位置
      startX: 0,//起始点
      currentX: 0,//当前点
    }
  },
  computed: {
    positionLeft() {
      let num = this.currentX - this.startX;
      if (num < 0) {
        num = 0;
      }
      if (num > 332) {
        num = 332;
      }
      return num + 'px'
    }
  },
  watch: {
    isShow(data) {
      if (data) {
        this.reset();
      }
    },
  },
  methods: {
    /**重置*/
    reset() {
      this.loading = true;
      this.dratStart = false;
      this.basePic = '';
      this.sliderPic = '';
      this.picPartPositionY = '0px';
      this.startX = 0;
      this.currentX = 0;
      this.getPic();
    },
    /**获取图片*/
    getPic() {
      this.loading = true;

      if (!this.getData) {
        alert('未获取资源');
        console.error('请检查获取资源的接口是否缺失');
        this.control(false);
        return;
      }

      this.getData().then(data => {

        let {
          basePic,
          sliderPic,
          picPartPositionY
        } = data;
        this.basePic = basePic;
        this.sliderPic = sliderPic;
        this.picPartPositionY = picPartPositionY + 'px';

        this.loading = false;
      }).catch(() => {
        this.loading = false;
        this.control(false);
      })
    },
    /**鼠标mousedown事件*/
    mouseDownEvent(e) {
      e.preventDefault();
      this.dragStart(e);
      window.addEventListener('mousemove', this.dragMoving);
      window.addEventListener('touchmove', this.dragMoving);
      window.addEventListener('mouseup', this.dragEnd);
      window.addEventListener('touchend', this.dragEnd);
      window.addEventListener('contextmenu', this.dragEnd);
    },
    /**拖拽开始*/
    dragStart(e) {
      if (e.type === 'touchstart') {
        e.clientX = e.touches[0].clientX
      }
      this.currentX = e.clientX;
      this.startX = e.clientX;
      this.dratStart = true;
    },
    /**拖拽进行中*/
    dragMoving(e) {
      if (this.dratStart) {
        if (e.type === 'touchmove') {
          e.clientX = e.touches[0].clientX
        }
        this.currentX = e.clientX;
      }
    },
    /**拖拽结束*/
    async dragEnd() {
      if (this.dratStart) {

        this.dratStart = false;
        this.loading = true;

        let result = await this.verify();
        if (result === 'success') {
          this.control(false)
          this.$emit('verifySuccess')
        } else if (result === 'fail') {
          this.reset()
        }
        this.loading = false;
      }
    },
    /**验证*/
    verify() {
      if (!this.validate) {
        alert('验证失败');
        console.error('请检查登录验证接口是否缺失');
        this.control(false);
        return;
      }

      let picCode = (this.currentX - this.startX).toFixed();
      return new Promise(resolve => {
        this.validate(picCode).then(() => {
          resolve('success')
        }).catch(() => {
          resolve('fail')
        })
      })
    },
    /**控制*/
    control(data) {
      this.$emit('control', data)
    }
  }
}
</script>

<style scoped>
@import "static/css/iconfont.css";

#__kk_slide_unlock {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 100;
  background-color: rgba(92, 92, 92, 0.3);
}

#__kk_slide_unlock .iconfont {
  font-size: 18px;
}

#__kk_slide_unlock .__kk_slide_unlock_inner {
  position: absolute;
  top: 40%;
  left: 50%;
  padding: 10px;
  background-color: #fff;
  transform: translate(-50%, -50%);
}

#__kk_slide_unlock .__kk_slide_unlock_pic_box {
  width: 380px;
  height: 200px;
  border: solid 1px transparent;
}

#__kk_slide_unlock .__kk_slide_unlock_pic {
  position: relative;
  width: 100%;
  height: 100%;
  background-position: top left;
  background-repeat: no-repeat;
}

#__kk_slide_unlock .__kk_slide_unlock_pic_part {
  position: absolute;
  width: 48px;
  height: 40px;
  background-position: top left;
  background-repeat: no-repeat;
}

#__kk_slide_unlock .__kk_slide_unlock_drag {
  position: relative;
  box-sizing: border-box;
  height: 42px;
  width: 100%;
  margin-top: 10px;
  background-color: #ccc;
  border: solid 1px #ccc;
}

#__kk_slide_unlock .__kk_slide_unlock_drag_bar {
  position: absolute;
  left: 0;
  top: 0;
  display: inline-block;
  height: 100%;
  background-color: #70c670;
}

#__kk_slide_unlock .__kk_slide_unlock_drag_tag {
  position: absolute;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 48px;
  height: 40px;
  background: #fff url("./static/img/slide-right.png") center center no-repeat;
  background-size: 50% 50%;
  cursor: pointer;
  z-index: 1;
}

#__kk_slide_unlock .__kk_slide_unlock_drag_tip {
  display: inline-block;
  width: 100%;
  line-height: 40px;
  text-align: center;
  background: -webkit-gradient(
    linear,
    left top,
    right top,
    color-stop(0, #4d4d4d),
    color-stop(0.4, #4d4d4d),
    color-stop(0.5, #fff),
    color-stop(0.6, #4d4d4d),
    color-stop(1, #4d4d4d)
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  -webkit-animation: __kk_slide_unlock 3s infinite;
  -webkit-text-size-adjust: none;
  user-select: none;
}

#__kk_slide_unlock .__kk_slide_unlock_operate {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  width: 100%;
  margin-top: 10px;
}

#__kk_slide_unlock .__kk_slide_unlock_operate > div {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
}

#__kk_slide_unlock .__kk_slide_unlock_operate_refresh {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  cursor: pointer;
}

#__kk_slide_unlock .__kk_slide_unlock_operate_close {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  cursor: pointer;
}

#__kk_slide_unlock .__kk_slide_unlock_operate_refresh .iconfont:hover {
  color: dodgerblue;
}

#__kk_slide_unlock .__kk_slide_unlock_operate_close .iconfont:hover {
  color: orangered;
}

#__kk_slide_unlock .__kk_slide_unlock_loading {
  position: absolute;
  top: 10px;
  left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 20px);
  height: calc(100% - 20px);
  background-color: rgba(0, 0, 0, 0.4);
  color: #fff;
  font-size: 15px;
  z-index: 10;
}

#__kk_slide_unlock .__kk_slide_unlock_loading .__kk_slide_unlock_loading_tag {
  width: 30px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  animation: __kk_slide_unlock_loading 2s infinite;
}

@keyframes __kk_slide_unlock_loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}

@keyframes __kk_slide_unlock {
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: 200px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/component/loginVerify/index.vue